import { parse as accountingParse } from 'accounting-js';
/**
 * Converts a formatted number or currency `String` to its equivalent `Number` value.
 * Wrapper for accounting-js `parse` (http://openexchangerates.github.io/accounting.js/#methods).
 *
 * @hidden
 * @param value The formatted string to be parsed.
 * @param decimalSeparator The decimal separator symbol used in the formatted string.
 * @returns The parsed `Number` value.
 */
export const parseNumber = (value, decimalSeparator) => {
    return accountingParse(value, decimalSeparator);
};
//# sourceMappingURL=parse-number.js.map